<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
    <div class="top">
        <a routerLink="/home/communication/news">
            <h3>Noticias /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2>{{ isEditMode ? (news.title || 'Editar noticia') : 'Añadir noticia' }}</h2>
            </div>
        </a>
    </div>
</div>

<form [formGroup]="newsForm" class="content">
    <h4>Título:</h4>
    <mat-form-field appearance="outline" id="title-form-field">
        <input type="text" matInput placeholder="Título" formControlName="name">
        @if (newsForm.get('name')?.invalid && newsForm.get('name')?.touched) {
        <mat-error>
            El título es requerido
        </mat-error>
        }
    </mat-form-field>

    <h4>Contenido:</h4>
    <quill-editor [modules]="modules" [styles]="{height: '300px'}" formControlName="content" class="quill-editor">
    </quill-editor>
    @if (newsForm.get('content')?.invalid && newsForm.get('content')?.touched) {
    <div class="error-message">
        El contenido es requerido
    </div>
    }

    <br><br>
    <div class="form-row">
        <mat-form-field appearance="outline">
            <mat-label>Categoría</mat-label>
            <input type="text" matInput placeholder="Categoría" formControlName="category">
            @if (newsForm.get('category')?.invalid && newsForm.get('category')?.touched) {
            <mat-error>
                La categoría es requerida
            </mat-error>
            }
        </mat-form-field>
    </div>

    <br><br>
    <div class="form-row">
        <mat-form-field appearance="outline" style="margin-right: 10px;">
            <mat-label>Fecha de publicación</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="publication_date">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            @if (newsForm.get('publication_date')?.invalid && newsForm.get('publication_date')?.touched) {
            <mat-error>
                La fecha de publicación es requerida
            </mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Hora publicación</mat-label>
            <input matInput type="time" formControlName="publication_time" />
            <mat-icon matSuffix>access_time</mat-icon>
        </mat-form-field>
    </div>

    <div class="options-row">
        <mat-checkbox formControlName="featured">Destacado</mat-checkbox>
        <mat-checkbox formControlName="notifications">Notificaciones</mat-checkbox>
        <mat-checkbox formControlName="allow_comments">Permitir comentarios</mat-checkbox>
    </div>

    <!-- Conditional image section based on edit mode -->
    @if (isEditMode && news.image_url && !imageRemoved) {
    <div class="media-header">
        <h4>Imagen actual:</h4>
    </div>
    <div class="existing-media">
        <div class="media-item">
            <div class="image-container">
                <img [src]="news.image_url" alt="News image" class="media-preview">
                <button mat-icon-button color="warn" type="button" (click)="removeImage()" class="delete-image-btn">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
            <div class="media-info">
                <p>{{news.image_url.split('/').pop() || 'Imagen de la noticia'}}</p>
            </div>
        </div>
    </div>
    } @else {
    <h4>Imagen{{ isEditMode ? ' (nueva)' : ' de la noticia' }}:</h4>
    <app-upload-files [singleFile]="true" (filesSelected)="onFileSelected($event)"></app-upload-files>
    @if (showImageRequiredError) {
    <div class="error-message" style="margin-top:4px;">La imagen es requerida cuando la noticia es destacada.</div>
    }
    }

    <br><br><br>
    <div class="form-row">
        <mat-form-field appearance="outline" style="width: 50%;">
            <mat-label>Tags</mat-label>
            <input type="text" matInput placeholder="Etiquetas" [value]="tagNamesString"
                (input)="updateTags($any($event.target).value)">
            <mat-hint>Ejemplo: noticia, serveto, importante (separados por comas)</mat-hint>
        </mat-form-field>
    </div>
    <br>
    <div class="buttons">
        <button mat-flat-button id="action" type="button" (click)="saveChanges()"
            [disabled]="isSubmitting || newsForm.invalid">
            @if (isSubmitting) {
            {{ isEditMode ? 'Actualizando...' : 'Guardando...' }}
            } @else {
            {{ isEditMode ? 'Actualizar' : 'Guardar cambios' }}
            }
        </button>
        <button mat-flat-button id="cancel" type="button" (click)="cancel()">Cancelar</button>
    </div>
</form>